<template lang="pug">
	v-card.mx-lg-auto.mt-md-4.mb-md-4(outlined width="100%" elevation="4" v-if="validVinSolutionsActivity" id="vin-solutions-activity-details-card")
		v-toolbar(flat :color="itemColor")
			v-btn(
				icon
				ripple
				@click="showDetails = !showDetails;"
			)
				v-icon.text-white(v-if="showDetails === true")
					| mdi-chevron-down
				v-icon.text-white(v-else)
					| mdi-chevron-right

			v-toolbar-title.text-white(style="width: 100%; padding: 0;")
				div.d-flex.justify-space-between.align-center(style="width: 100%;")
					span.text-h7(v-if="isCreateNote && validNoteType")
						| Create {{ vinSolutionsActivity.note_type + " Note" | titleize }} 
						//- create email note / create message note, etc
					span.text-h7(v-else)
						| {{ vinSolutionsActivity.command_name || "---"  | titleize }}
					span.text-body-2.text-uppercase.font-weight-bold
						| {{ vinSolutionsActivity.status || "---" | titleize }}
				div.text-body-2.mt-2
					| {{ vinSolutionsActivity.created_at || "---" }}

		v-card-text.white.text--primary(v-if="showDetails")
			v-list
				v-list-item(v-if="validLogNote")
					v-list-item-icon
						v-icon.volie-color-blue mdi-information-outline
					v-list-item-content.volie-color-blue
						v-list-item-title Description:
						v-list-item-subtitle.text-wrap {{ vinSolutionsActivity.log_note || "---" }}

				v-list-item(v-if="isCreateNote")
					v-list-item-icon
						v-icon.volie-color-blue mdi-information-outline
					v-list-item-content.volie-color-blue
						v-list-item-title Content:
						v-list-item-subtitle.text-wrap {{ vinSolutionsActivity.note_content || "---" }}

				v-list-item(v-if="isErrorStatus")
					v-list-item-icon
						v-icon(color="error") mdi-alert
					v-list-item-content
						v-list-item-title(style="color: var(--error);") ERROR: 
							v-list-item-subtitle(v-if="isCreateNote && validNoteType") Vin Solutions was Unable to Create {{ vinSolutionsActivity.note_type + " Note" | titleize }}
							v-list-item-subtitle(v-else) Vin Solutions was Unable to {{ vinSolutionsActivity.command_name || "Complete Activity" | titleize }}

				v-list-item(v-else-if="isSuccessStatus")
					v-list-item-icon
						v-icon(color="success") mdi-check
					v-list-item-content(v-if="isCustomerUpdate")
						v-list-item-title(style="color: var(--success);") Successfully Updated Customer
					v-list-item-content(v-else-if="isCreateCallLog")
						v-list-item-title(style="color: var(--success);") Successfully Created Call Log
					v-list-item-content(v-else-if="isCreateNote && validNoteType")
						v-list-item-title(style="color: var(--success);") Successfully Created {{ vinSolutionsActivity.note_type + " Note" | titleize }}
					v-list-item-content(v-else-if="isCreateNote")
						v-list-item-title(style="color: var(--success);") Successfully Created Note
					v-list-item-content(v-else)
						v-list-item-title(style="color: var(--success);") Successfully Completed Activity

				v-list-item(v-else-if="isFailedStatus")
					v-list-item-icon
						v-icon(color="error") mdi-alert
					v-list-item-content
						v-list-item-title(style="color: var(--error);") REQUEST FAILED:
							v-list-item-subtitle(v-if="isCreateNote && validNoteType") Unable to Create {{ vinSolutionsActivity.note_type + " Note" | titleize }}
							v-list-item-subtitle(v-else) Unable to {{ vinSolutionsActivity.command_name || "Complete Activity" | titleize }}

				v-list-item(v-else-if="isOtherStatus")
					v-list-item-icon
						v-icon(color="warning") mdi-information-outline
					v-list-item-content
						v-list-item-title(style="color:var(--orange);") Activity in {{ vinSolutionsActivity.status || "---" | titleize }} Status

				v-list-item(v-if="validUpdatedFields")
					v-list-item-icon
						v-icon.volie-color-blue mdi-update
					v-list-item-content.volie-color-blue
						v-list-item-title Updated Fields:

				v-list-item(v-if="validUpdatedFields" v-for="(field, _) in vinSolutionsActivity.updated_fields" :key="field.field_name")
					v-list-item-icon
						v-icon.volie-color-blue mdi-arrow-right-thin
					v-list-item-content.volie-color-blue
						v-list-item-subtitle.text-wrap
							| Changed {{ field.field_name | titleize }} from "{{ field.old_value }}" to "{{ field.new_value }}"

</template>

<script lang="ts">
	import Vue from 'vue';

	// Components
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

	// Helpers
	import { resourceColorClass, } from "@/helpers/css_classes";

	export default Vue.extend({
		data() {
			return {
				vinSolutionsActivityLineLineCardWidth: 300,
				showDetails: false,
			}
		},
		methods: {
			handleVinSolutionsActivityDetailsResize() {
				const vinSolutionsActivityDetailsWidth = document?.getElementById('vin-solutions-activity-details-card')?.getBoundingClientRect()?.width
				if (vinSolutionsActivityDetailsWidth >= 375) {
					this.vinSolutionsActivityLineLineCardWidth = vinSolutionsActivityDetailsWidth - 75
				} else {
					this.vinSolutionsActivityLineLineCardWidth = 300
				}
			},
		},
		computed: {
			isCustomerUpdate() {
				return this.vinSolutionsActivity?.command_name?.toLowerCase() === 'update_customer';
			},
			isCreateCallLog() {
				return this.vinSolutionsActivity?.command_name?.toLowerCase() === 'create_call_log';
			},
			isCreateNote() {
				return this.vinSolutionsActivity?.command_name?.toLowerCase() === 'create_note';
			},
			isErrorStatus() {
				return this.vinSolutionsActivity?.status?.toLowerCase() === 'error';
			},
			isFailedStatus() {
				return this.vinSolutionsActivity?.status?.toLowerCase() === 'failed';
			},
			isSuccessStatus() {
				return this.vinSolutionsActivity?.status?.toLowerCase() === 'success' || this.vinSolutionsActivity?.status?.toLowerCase() === 'completed';
			},
			isOtherStatus() {
				return this.vinSolutionsActivity?.status?.length > 0 && !this.isErrorStatus && !this.isSuccessStatus && !this.isFailedStatus;
			},
			itemColor() {
				return resourceColorClass(this.activityType) || 'grey';
			},
			validLogNote() {
				return this.vinSolutionsActivity?.log_note?.length > 0;
			},
			validNoteType() {
				return this.vinSolutionsActivity?.note_type?.length > 0;
			},
			validVinSolutionsActivity() {
				return this.vinSolutionsActivity?.vid?.length > 0;
			},
			validUpdatedFields(){
				return this.vinSolutionsActivity?.updated_fields?.length > 0;
			}
		},
		components: {
			StrLimitTooltipText,
		},
		props: {
			vinSolutionsActivity: Object,
			activityType: String,
		},
		watch: {
			vinSolutionsActivity: {
				handler() {
					Vue.nextTick(() => { this.handleVinSolutionsActivityDetailsResize(); });
				},
				deep: true,
			},
		},
		created() {
			window.addEventListener('resize', this.handleVinSolutionsActivityDetailsResize);
		},
		destroyed() {
			window.removeEventListener('resize', this.handleVinSolutionsActivityDetailsResize);
		},
		mounted() {
			this.handleVinSolutionsActivityDetailsResize();
		},
	});
</script>

<style lang="scss" scoped>
	#app {

		.cell-value-spacing {
			padding: 0 0 5px 0;
		}

		.m-l-5 {
			margin-left: 5px;
		}
	}
</style>
